<template>
  <div>
    <v-card v-if="editedItem">
      <v-card-title>
        <span class="text-h5">{{ $t("admin.stories.editStory") }}</span>
      </v-card-title>
      <v-card-text v-if="editedItem">
        <v-form ref="basic-info-form">
          <v-container fluid class="pa-10">
            <v-row>
              <v-col cols="12" class="px-5">
                <StoryTitle
                  v-model="localEditedStory.name"
                  :disabled="updateOrLoadInProgress"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="7" class="px-5">
                <Tagline
                  v-model="localEditedStory.summary"
                  :disabled="updateOrLoadInProgress"
                />
                <Description />
              </v-col>
              <v-col md="5" sm="12" class="px-5 right-column">
                <Genre v-model="genre" @genreObject="genreObject" />
                <AgeRating
                  v-model="ageRating"
                  @ageRatingObject="ageRatingObject"
                />
                <Tags v-model="tags" @tagsObject="tagsObject" />
                <Duration
                  v-model="localEditedStory.duration"
                  :disabled="updateOrLoadInProgress"
                />
                <TemplateOptions
                  :story="localEditedStory"
                  :disabled="updateOrLoadInProgress"
                  @updateStory="localEditedStory = $event"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="reset">
          {{ $t("forms.cancel") }}
        </v-btn>
            <v-btn :loading="getInProgress" :disabled="getInProgress" color="blue darken-1" @click="saveStory">
              {{ $t("forms.save") }}
            </v-btn>
            <div v-for="errorMessage in getErrorMessages" :key="errorMessage">
            {{ errorMessage }}
            </div>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import storyBasicInfoForm from "@/mixins/storyBasicInfoForm";
import storyMutations from "@/graphql/StoryMutations";
export default {
  mixins: [storyBasicInfoForm],
  props: {
    availableStatuses: Array,
    editedItem: Object,
  },
  data() {
    return {
      status: this.editedItem.status.id,
    };
  },
  computed: {
    updateStoryQuery() {
      return storyMutations.updateStoryStatus;
    },
    id() {
      return this.editedItem.id;
    },
  },
  watch: {
    getSuccess() {
      this.reset()
    }
  },
  methods: {
    reset() {
      this.$emit("reset");
    },
  },
};
</script>

